import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { leaveAssessmentSession, SignalRContext } from '../../Context/SignalR.context';
import { CallbackMethodNames } from '../../models/signalR.types';
import { RootState } from '../../store';
import { Paths } from '../../utils/routerUrls';
import { Prompt } from '../Prompt/Prompt.component';
import { AssessmentSessionState} from '../../pages/Dashboard/Dashboard.types';
import { setAssessmentSessionEvent } from '../../services/scoring/scoring.service';
import useSessionUser from '../../hooks/useSessionUser';
import { needToNotifyAboutLeaveAssessmentProcess } from '../../utils/assessmentSessionProcess';

export const SessionSuspended: React.FC<{ assessmentSessionId: string, assessmentSessionStateId?: AssessmentSessionState }> = (props) => {
  const history = useHistory();
  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession);
  const [isSessionSuspended, setIsSessionSuspended] = useState<boolean>(false);

  const { userAssessmentSessionInfo } = useSessionUser();
  const userFunction = userAssessmentSessionInfo.function;

  SignalRContext.useSignalREffect(
    CallbackMethodNames.AssessmentSessionSuspended,
    (message) => {
      if (props.assessmentSessionId === message.assessmentSessionId) setIsSessionSuspended(true);
    },
    [],
  );

  useEffect(() => {
    if (props.assessmentSessionStateId === AssessmentSessionState.Suspended) setIsSessionSuspended(true);
  }, [props.assessmentSessionStateId]);

  const redirectToDashboard = () => {
    leaveAssessmentSession(assessmentSession);
    if (needToNotifyAboutLeaveAssessmentProcess(assessmentSession, userFunction)) {
      setAssessmentSessionEvent(2);
    }
    sessionStorage.removeItem('startWork');
    history.push(Paths.dashboard);
  };

  return (
    <Prompt
      type="warning"
      open={isSessionSuspended}
      mainText={'Sesja została zawieszona'}
      subTexts={[
        {
          text: 'W tym stanie nie możesz pobierać, oceniać, odsyłać RGZ ani zgłaszać szczególnego przypadku. Niedługo sesja zostanie ponownie otwarta. ',
        },
      ]}
      mainActionButtonText="OK"
      onConfirm={redirectToDashboard}
    />
  );
};
